import React from 'react';
import { ResponsiveBar } from '@nivo/bar'



const BarChart = ({ data, x, y, isDarkMode }) => {

  const barData = data.map((row) => ({
    [x]: row[0], 
    [y]: row[1], 
  }));

  const theme = {
    axis: {
      ticks: {
        text: {
          fill: isDarkMode ? '#cbd5e1' : '#374151',
        },
      },
      legend: {
        text: {
          fill: isDarkMode ? '#cbd5e1' : '#374151',
        },
      },
    },
    grid: {
      line: {
        stroke: isDarkMode ? '#334155' : '#e5e7eb',
      },
    },
    tooltip: {
      container: {
        background: isDarkMode ? '#1e293b' : '#ffffff',
        color: isDarkMode ? '#cbd5e1' : '#111827',
        border: `1px solid ${isDarkMode ? '#475569' : '#d1d5db'}`,
      },
    },
  };

  return (
    <div className={barData.length > 0 ? 'h-96' : 'h-20'}>
      <ResponsiveBar
        data={barData}
        keys={[y]}
        indexBy={x}
        margin={{ top: 50, right: 50, bottom: 60, left: 100 }}
        padding={0.4}
        colors={isDarkMode ? '#60a5fa' : '#3182CE'}
        animate={true}
        enableLabel={false}
        axisTop={null}
        axisRight={null}
        theme={theme}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: y,
          legendPosition: "middle",
          legendOffset: -80
        }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: x,
          legendPosition: "middle",
          legendOffset: 40
        }}
      />
    </div>
  );
};
export default BarChart;
